import { filter } from '../helpers/filter';

import contactImg from '../images/sabrina_results.png';

const botName = "Isa"
const helloIcon = "🙋‍♀️"
const contactLink = "https://www.territory-influence.com/en/contact/"
const imprintLink = "https://www.territory-influence.com/en/imprint/"
const termsLink = "https://www.territory-influence.com/en/termsofuse/"
const privacyLink = "https://www.territory-influence.com/en/privacypolicy"

const infTypes = {
  "nano": {
    "short": "Nano",
    "long": "Nano Influencers",
  },
  "micro": {
    "short": "Micro",
    "long": "Micro Influencers",
  },
  "macro": {
    "short": "Macro",
    "long": "Macro Influencers",
  },
  "star": {
    "short": "Star",
    "long": "Star Influencers",
  },
}

const goalTypes = {
  "wom": {
    "title": "Recommendations",
    "description": `Personal recommendations (or word-of-mouth/WOM) between consumers are triggered by Nano Influencers. At TERRITORY Influence, we draw on a pool of over 4 million influencers in Europe, which we select to suit your target group.`,
  },
  "insights": {
    "title": "Consumer Insights",
    "description": `Through Nano Influencers on our platforms, we collect feedback on your product or brand in the shortest possible time. Whether from 100 or 10,000 consumers - our Nano Influencers love to support you with their opinion.`,
  },
  "posTraffic": {
    "title": "POS Traffic",
    "description": `Equipped with extensive background information, we use Nano Influencers to generate traffic at your POS. Whether offline or online: they visit your shop together with friends and thus generate additional sales and new customers.`,
  },
  "premiumTrials": {
    "title": "Premium Trials",
    "description": `Through the targeted use of Nano Influencers we generate relevant product experiences with a high target group fit. Nano Influencers know exactly for whom from their environment a product is suitable and thus generate trials with low dispersion loss and high added value.`,
  },
  "ratings": {
    "title": "Ratings & Reviews",
    "description": `Whether in e-commerce or on product rating pages - authentic ratings & reviews from real consumers have a positive effect on the purchase decision. We know from over 2,000 campaigns: Nano Influencers are best suited for this.`,
  },
  "authContent": {
    "title": "Authentic Content",
    "description": `Especially Nano and Micro Influencers are our first choice if you need authentic content on the Social Web. If necessary, you can license the generated content pieces and use them on your own channels.`,
  },
  "engagement": {
    "title": "Engagement",
    "description": `Micro and Macro Influencers shine through their closeness to their followers in social media through particularly high engagement rates. That's why they are your first choice if your goal is engagement.`,
  },
  "onlineReach": {
    "title": "Online Reach",
    "description": `The best way to achieve relevant online reach is to use different influencer combinations. Whether a single Star Influencer or several thousand Nano Influencers - a meaningful strategy depends on your other goals, target group or industry.`,
  },
  "websiteTraffic": {
    "title": "Website Traffic",
    "description": `Through the targeted use of Macro or Star Influencers we generate additional traffic on your websites.`,
  },
  "profContent": {
    "title": "Professional Content",
    "description": `Due to the affinity to their topics and special fields we recommend Macro Influencers for the production of professional content.`,
  },
  "productStaging": {
    "title": "Product Staging",
    "description": `Product staging is the strength of Macro and Star Influencers. With their professional know-how and experience, they know how to present products and brands and thus produce high-quality content.`,
  },
  "storytelling": {
    "title": "Storytelling",
    "description": `Macro Influencers are at home in defined categories and are therefore experts in their field. Storytelling around a certain topic therefore works particularly well with them.`,
  },
  "imageShaping": {
    "title": "Image Shaping",
    "description": `Image shaping is the strength of Star Influencers. These personalities, known to a very broad target group, manage to transfer their own image and their own positive appeal to your brand or product.`,
  },
  "testimonials": {
    "title": "Testimonials",
    "description": `Testimonials can be found among the Star Influencers. The right strategy depends on your other goals and your personal preferences.`,
  },
  "awareness": {
    "title": "Awareness",
    "description": `We can generate awareness across all influencer categories. Ultimately, your personal preferences and the overall strategy of your influencer action are decisive.`,
  },
  "sampling": {
    "title": "Sampling",
    "description": `With access to over 4 million influencers throughout Europe, we can carry out targeted sampling campaigns using Nano, Micro, Macro or Star Influencers.`,
  },
  "education": {
    "title": "Education",
    "description": `Complex products requiring explanation are ideal for the use of Nano, Micro or Macro Influencers. They can, for example, bring complex product features closer to their environment in a personal conversation or via tutorials.`,
  },
}

const welcomeScreen = {
  "h1": "A clear view on your influencer strategy!",
  "h2": "Finding the right influencer strategy is not easy. Our data-based quick check helps you to make an initial assessment of a suitable strategy for your brand and your product in just a few minutes!",
  "button": "Start check",
}

const appLoader = {
  "initializing": "Initializing app",
  "waking": "Waking up assistant",
  "ready": "Let's go!",
}

export const en = (data) => {

  const { product, industries, goals, recommendation } = data
  const filteredProduct = filter.clean(product)
  const topOne = recommendation.topOne.length > 0 && infTypes[recommendation.topOne]
  const topTwo = recommendation.topTwo.length > 0 && infTypes[recommendation.topTwo]

  return {
    botName,
    helloIcon,
    welcomeScreen,
    appLoader,
    "botMessages": {
      "m1": {
        "comment": `Hi! I am ${botName}, your virtual assistant. ${helloIcon} I will help you find the right influencer strategy for your product or brand.`,
      },
      "m2": {
        "comment": "We'd better get to know each other for a minute. Let's go ...",
        "question": "Which company do you work for?",
      },
      "m4": {
        "comment": "Wonderful! This information helps me to personalize your result even better. 😊",
      },
      "m5": {
        "comment": "Let's move on ...",
        "question": "Which product or brand would you like to work with Influencers for?",
      },
      "m7": {
        "comment": "Very nice.",
        "question": `What goals do you pursue with an influencer campaign for "${filteredProduct}"?`,
      },
      "m91": {
        "comment": "Hm ...",
        "question": "Quite a lot of goals. Here a personal consultation would make more sense now!",
        "addon": "Alternatively you can reduce the number of your goals to max. 4 ...",
        "button": "Request consultation",
        "contactLink": contactLink,
      },
      "m92": {
        "comment": "Okay.",
        "question": `Which category does "${filteredProduct}" belong to?`,
        "addon": "Please select max. 2 product categories ...",
      },
      "m11": {
        "comment": "We're almost there. Just two short questions about the target group ...",
        "question": `How old is the target group for "${filteredProduct}"?`,
        "addon": "Please select all age groups that apply ...",
      },
      "m13": {
        "question": "And the sex?",
      },
      "m15": {
        "comment": "Great. Now we're done. Unless you want to tell me something else ...",
        "question": "Is there anything else I should know?",
        "addon": "For example about your goals, the product or the target group ...",
      },
      "m17": {
        "comment": "Nice to meet you. I like to talk to you! 😊",
        "question": "What else would you like to tell me?",
      },
      "m1000": {
        "comment": "All right, all right. I now calculate your result ...",
      },
      "m1001": {
        "comment": "Okay, ready! 💪",
        "question": "Here is an initial assessment based on your briefing:",
      },
    },
    "inputs": {
      "goals": {
        "wom": goalTypes.wom.title,
        "insights": goalTypes.insights.title,
        "posTraffic": goalTypes.posTraffic.title,
        "premiumTrials": goalTypes.premiumTrials.title,
        "ratings": goalTypes.ratings.title,
        "authContent": goalTypes.authContent.title,
        "engagement": goalTypes.engagement.title,
        "onlineReach": goalTypes.onlineReach.title,
        "websiteTraffic": goalTypes.websiteTraffic.title,
        "profContent": goalTypes.profContent.title,
        "productStaging": goalTypes.productStaging.title,
        "storytelling": goalTypes.storytelling.title,
        "imageShaping": goalTypes.imageShaping.title,
        "testimonials": goalTypes.testimonials.title,
        "awareness": goalTypes.awareness.title,
        "sampling": goalTypes.sampling.title,
        "education": goalTypes.education.title,
      },
      "industries": {
        "beauty": "Beauty",
        "automotive": "Automotive",
        "travel": "Travel",
        "pharma": "Pharma",
        "tech": "Tech",
        "eCom": "eCommerce",
        "fashion": "Fashion",
        "foodBev": "Food & Beverages",
        "household": "Household",
        "finance": "Finance & Insurance",
        "games": "Toys",
        "energy": "Energy",
        "other": "Others",
      },
      "ageRanges": {
        "1to5": "1 - 5",
        "6to12": "6 - 12",
        "13to18": "13 - 18",
        "19to24": "19 - 24",
        "25to34": "25 - 34",
        "35to44": "35 - 44",
        "45to54": "45 - 54",
        "55to64": "55 - 64",
        "65plus": "65+",
      },
      "gender": {
        "male": "Male",
        "female": "Female",
      },
      "else": {
        "yes": "Yes",
        "no": "No",
      },
      "buttons": {
        "confirm": "Confirm",
      },
    },
    "results": {
      "h1": `My Recommendation for ${filteredProduct}`,
      "h2": {
        "single": `Your individual briefing indicates a strategy with focus on ${topOne.long}.`,
        "multiple": `Your individual briefing indicates a strategy with focus on ${topOne.short} and ${topTwo.long}.`,
      },
      "infTypes": {
        "nano": {
          "title": infTypes.nano.long,
          "description": `${infTypes.nano.long} are enthusiastic consumers who spread credible recommendations within their peer groups through personal conversations, shared product experiences and posts on social networks.`,
        },
        "micro": {
          "title": infTypes.micro.long,
          "description": `${infTypes.micro.long} are brand ambassadors with 1,000 - 100,000 followers who generate organic online reach through authentic social content and high engagement.`,
        },
        "macro": {
          "title": infTypes.macro.long,
          "description": `${infTypes.macro.long} are content creators with more than 100,000 followers who address a broad audience with high-quality content and thus create image effects for brands and products.`,
        },
        "star": {
          "title": infTypes.star.long,
          "description": `${infTypes.star.long} are testimonials with massive personal social media audiences who are also prominent beyond social media and thereby create a high level of brand visibility and product appeal.`,
        },
      },
      "hint": "Please note that my recommendation is only an initial assessment based on the data you have entered and does not replace a personal consultation. Depending on how you weight your goals or how much budget you have available, a different strategy may be useful.",

      "background": {
        "headline": "Background to the Recommendation",
        "description": "The conception of influencer campaigns clearly focuses on your needs. Your individual goals, industry and target group play a central role. In the following I will explain to you how these factors influence your analysis results.",
        "basis": {
          "headline": "Your Briefing as a Basis",
          "product": "Product/Brand:",
          "goals": goals.length > 1 ? "Goals:" : "Goal:",
          "industries": industries.length > 1 ? "Industries:" : "Industry:",
          "target": "Target group:",
          "other": "Others:",
          "helpers": {
            "male": "Men",
            "female": "Women",
            "and": "and",
            "years": "years",
            "allRanges": "in all age ranges",
            "multipleRanges": "in the age ranges of",
            "singleRange": "in the age range of",
          },
        },
        "goals": {
          "headline": goals.length > 1 ? "Goals" : "Goal",
          "wom": goalTypes.wom.description,
          "insights": goalTypes.insights.description,
          "posTraffic": goalTypes.posTraffic.description,
          "premiumTrials": goalTypes.premiumTrials.description,
          "ratings": goalTypes.ratings.description,
          "authContent": goalTypes.authContent.description,
          "engagement": goalTypes.engagement.description,
          "onlineReach": goalTypes.onlineReach.description,
          "websiteTraffic": goalTypes.websiteTraffic.description,
          "profContent": goalTypes.profContent.description,
          "productStaging": goalTypes.productStaging.description,
          "storytelling": goalTypes.storytelling.description,
          "imageShaping": goalTypes.imageShaping.description,
          "testimonials": goalTypes.testimonials.description,
          "awareness": goalTypes.awareness.description,
          "sampling": goalTypes.sampling.description,
          "education": goalTypes.education.description,
        },
      },
    },
    "contact": {
      "h1": "Learn more",
      "p": "My colleagues will be happy to talk to you personally to explain your optimal strategy. Just tell me your contact details and my colleagues will get back to you as soon as possible.",
      "form": {
        "headline": "Your Contact Details",
        "optional": "optional",
        "button": "Send",
        "legal": 'When I click on "Send", the information I provide will be used by Territory Influence for the purpose of contacting me regarding a possible collaboration. Territory Influence uses the Google Firebase service. Further information on the storage and use of my personal data by Territory Influence and on the use of Firebase can be found in the Privacy Policy.',
      },
      "mail": "beratung@territory.group",
      "phone": "+49 (0) 89 307 668 0",
    },
    "thankYou": {
      "h1": "Thank you very much. We will get back to you as soon as possible.",
      "h3": "If you want you can also contact my colleague Sabrina directly!",
      "phone": "+49 (0) 40 370 339 98",
      "mail": "prumbs.sabrina@territory.group",
      "image": contactImg,
    },
    "error": {
      "h1": "Oops ...",
      "h3": "Something's gone wrong.",
      "contact": "Contact us best directly:",
      "button": "Contact us now",
      "contactLink": contactLink,
    },
    "legalBox": {
      "imprint": {
        "title": "Imprint",
        "link": imprintLink,
      },
      "terms": {
        "title": "Terms of Use",
        "link": termsLink,
      },
      "privacy": {
        "title": "Privacy Policy",
        "link": privacyLink,
      },
    },
    "placeholders": {
      "companyName": "Company name or URL ...",
      "productName": "Product or brand name ...",
      "other": "Please enter your message ...",
    }
  }
}
